<template>
  <div>
    <v-app>
      <NavBar v-if="uiStore.navBarVisible" />
      <v-main>
        <router-view />
      </v-main>
      <v-footer app v-if="uiStore.navBarVisible">
        <div class="text-left copyright">
          Copyright 2026, 27pub.com,
          <router-link :to="{ name: 'ReleaseNotes' }">v 0.61 </router-link> 

          <p>><router-link :to="{ name: 'PrivacyPolicy' }">Privacy Policy, </router-link>  </p>
            <p>><router-link :to="{ name: 'TermsOfService' }">Terms of Service</router-link></p>
          </div>
      </v-footer>
    </v-app>
  </div>
</template>

<script setup>
import NavBar from '@/components/navigation/NavBar'
import { useUserStore } from '@/stores/users'
import { useUiStore } from '@/stores/ui'
import { onMounted } from 'vue'

const userStore = useUserStore()
const uiStore = useUiStore()

onMounted(() => {
  // checkLogin will set up the onAuthStateChanged listener
  userStore.checkLogin();
})
</script>

<style>
#app {
  font-family: 'DM Sans', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #1A1A2E;
}
.copyright {
  margin-top: 20px;
  font-size: .8em;
}
</style>
